import React from "react";
import { Controller } from "react-hook-form";
import "./RadioButton.css";

const RadioButtonGroups = ({ options, name, control, parentLabel, mandatory, hasWebAccess }) => {
  console.log("Received Parent Label:", parentLabel);
  console.log("Received Options:", options);
  console.log("Name:", name);

  if (!options || !Array.isArray(options)) {
    console.error("Options is not defined or not an array:", options);
    return (
      <div className="radio-group-container">
        {parentLabel && (
          <label className="radio-parent-label" style={{ color: "white" }}>
            {parentLabel}
            {mandatory && <span className="mandatory-asterisk"> *</span>}
          </label>
        )}
        <div>No options available</div>
      </div>
    );
  }
  return (
    <div className="radio-group-container">
      {parentLabel && (
        <label className="radio-parent-label" style={{ color: "white" }}>
          {parentLabel}
          {mandatory && <span className="mandatory-asterisk"> *</span>}
        </label>
      )}
      <div className="radio-group div-space-adminrole">
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value } }) => (
            <>
              {options.map((option) => (
                <label key={option.value} className="radio-container">
                  <span className="dynamic__radio--label label-adminrole">{option.label}</span>
                  <input
                    className="radio-adminrole"
                    type="radio"
                    value={option.value}
                    checked={value === option.value}
                    onChange={(e) => onChange(e.target.value)}
                    // disabled={!hasWebAccess}
                  />
                </label>
              ))}
            </>
          )}
        />
      </div>
    </div>
  );
};

export default RadioButtonGroups;
